import { IonButton, IonCol, IonImg, IonContent, IonGrid, IonPage, IonPopover, IonRow, IonText, useIonViewDidLeave, useIonViewWillEnter, useIonViewWillLeave } from '@ionic/react';
import { useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import Footer from '../../components/Footer';
import { Fundraiser, User } from '../../models/data';
import { translation } from '../../models/translation';
import AuthServ from '../../services/auth';
import { fetchFundraiserProgress, fetchSingleFundraiser } from '../../services/fundraise_service';
import { fetchOrg } from '../../services/org_service';
import { getDaysRemaining } from '../../utlities/daysRemainings';
import { d_m_y } from '../../utlities/ymd';

interface FundraiserDetailProps {
  user: User | any
}
const FundraiserDetail: React.FC<FundraiserDetailProps> = ({ user }) => {
  const history = useHistory();

  const pathName = useLocation().pathname;

  const isAccountPage = () => {
    if (pathName.indexOf('account') < 0) return false;
    return true
  }
  const loginFirst = () => {
    history.push({ pathname: `/${lan}/signin`, state: { destination: `/account/direct_to_fundraiser?id=${id}` } })
  }

  const { id } = useParams<{ id: string; }>();

  const siteText = translation();
  const lan = siteText.lan.replace("/", "");

  const Auth = new AuthServ();
  const [fundraiser, setFundraiser] = useState<Fundraiser | null>(null)
  const [fundraiserProgress, setFundraiserProgress] = useState<any>(null)
  const [author, setAuthor] = useState<any>(null)
  const [authorOrg, setAuthorOrg] = useState<any>(null)

  const popover = useRef<HTMLIonPopoverElement>(null);
  const [popoverOpen, setPopoverOpen] = useState(false);
  const openPopover = (e: any) => {
    popover.current!.event = e;
    setPopoverOpen(true);
  };

  useIonViewWillEnter(() => {
    fetchSingleFundraiser(id).then(
      m => {
        Auth.fetchAUser(m.message.author).then(
          n => {
            let authorOrgId = m.message.acf.author_org;
            setAuthor(n.message)
            setFundraiser(m.message);
            fetchFundraiserProgress(id).then(
              o => {
                setFundraiserProgress(o?.message)
              }
            )
            if (authorOrgId) fetchOrg(authorOrgId).then(
              p => {
                if (!p.error) {
                  setAuthorOrg(p.message)
                }
              }
            )
          }

        )

      }
    )
  }, [id])

  useIonViewWillLeave(() => {
    setPopoverOpen(false);

  })

  useIonViewDidLeave(() => {
    setAuthorOrg(null)
  })

  const startDonating = () => {
    if (isAccountPage()) { history.push(`../direct_to_fundraiser?id=${id}`) } else {
      history.push(`/${lan}/account/direct_to_fundraiser?id=${id}`)
    }



  }

  const ymdtoDate = (date: any) => {
    let converted = d_m_y(date)
    return converted.toLocaleDateString(undefined);
  }

  return (
    <IonPage className=''>
      <IonContent >
        {fundraiser &&
          <IonGrid className="article-body">
            {
              fundraiser.acf.image &&
              <IonRow >
                <IonCol offsetSm='1' sizeSm="10" className='header_273 article-header' style={{ borderRadius: '15px 15px 0 0', padding:'0'}}>
                  <IonImg src={fundraiser.acf.image}></IonImg>
                </IonCol>
              </IonRow>
            }
            <IonRow>
              <IonCol offsetSm='1' sizeSm="10" style={{ backgroundColor: 'white' }}  >

                <IonRow className='ion-hide-sm-down accountSectionSpacingBottom'>
                  <IonCol offsetSm="1" sizeSm='7' sizeMd="8" offsetMd='1'>
                    <h1 dangerouslySetInnerHTML={{__html:`+${fundraiser.title.rendered}`}}></h1>
                    {authorOrg &&
                      <p>{siteText.createBy} <Link to={isAccountPage() ? `/${lan}/account/charities/${authorOrg.id}` : `/${lan}/charities/${authorOrg.id}`}> {authorOrg.acf[lan].nom}</Link> </p>
                    }
                    {!authorOrg &&
                      <p>{siteText.createBy}{author.name}</p>
                    }


                    <p>{siteText.fundraiseDetailDestinationKey} :{fundraiser.acf.destination !== "self" ? ` ${fundraiser.acf.destination_org.post_title}` : `${siteText.fundraiseDetailDestinationSw}`}</p>
                    <h5>{siteText.fundraiseDetailMotivationKey} : {fundraiser.acf.reason}</h5>
                    <p dangerouslySetInnerHTML={{ __html: fundraiser.acf.description }}></p>
                  </IonCol>
                  <IonCol sizeSm='3'>
                    {fundraiser.acf.status && <h4><IonText color='success'>*{siteText.fundraiseCompletedTxt}</IonText></h4>}
                    {fundraiserProgress &&
                      <>
                        <h4>{fundraiserProgress.raised} CHF</h4>
                        <p>{siteText.fundraiseDetailProgress.replace('%%target%%', fundraiser.acf.target)}</p>
                      </>
                    }
                    <h4>{getDaysRemaining(fundraiser.acf.end_date) > 0 ? getDaysRemaining(fundraiser.acf.end_date) : 0} {siteText.days}</h4>
                    <p>{siteText.fundraiseDetailDeadline} {ymdtoDate(fundraiser.acf.end_date)}</p>
                    {!fundraiser.acf.status && <IonButton mode='ios' expand='block' onClick={e => !user ? openPopover(e) : startDonating()} ><IonText color='light'>{siteText.fundraiseDetailPrimary}</IonText></IonButton>}
                  </IonCol>
                </IonRow>
                <IonRow className='ion-hide-sm-up'>

                  <IonCol size="12">
                    <h1 className='h2'>+{fundraiser.title.rendered}</h1>
                    {authorOrg &&
                      <p className='smallText' style={{ margin: 0 }}><strong>{siteText.createBy}</strong> <Link to={isAccountPage() ? `/${lan}/account/charities/${authorOrg.id}` : `/${lan}/charities/${authorOrg.id}`}> {authorOrg.acf[lan].nom}</Link> </p>
                    }
                    {!authorOrg &&
                      <p className='smallText' style={{ margin: 0 }}><strong>{siteText.createBy}</strong>{author.name}</p>
                    }
                    <p className='smallText' style={{ margin: 0 }}><strong>{siteText.fundraiseDetailDestinationKey} </strong>:{fundraiser.acf.destination !== "self" ? ` ${fundraiser.acf.destination_org.post_title}` : " My Swiss donations account"}</p><br />
                    <p className='smallText' style={{ margin: 0 }}><strong>{siteText.fundraiseDetailMotivationKey}</strong> : {fundraiser.acf.reason}</p>
                  </IonCol>
                  <IonCol size='12'>
                    <IonRow>
                      <IonCol>
                        {fundraiserProgress &&
                          <>
                            <p><strong>{fundraiserProgress.raised} CHF</strong> <br />
                              <span className='smallText'>{siteText.fundraiseDetailProgress.replace('%%target%%', fundraiser.acf.target)}</span>
                            </p>
                          </>
                        }
                      </IonCol>
                      <IonCol>
                        <p><strong>{getDaysRemaining(fundraiser.acf.end_date) > 0 ? getDaysRemaining(fundraiser.acf.end_date) : 0} {siteText.days}</strong> <br />
                          <span>{siteText.fundraiseDetailDeadline} {ymdtoDate(fundraiser.acf.end_date)}</span>
                        </p>
                      </IonCol>
                    </IonRow>
                  </IonCol>
                  <IonCol size='12'>
                    {!fundraiser.acf.status && <IonButton size='small' mode='ios' onClick={e => !user ? openPopover(e) : startDonating()} ><IonText color='light'>{siteText.fundraiseDetailPrimary}</IonText></IonButton>}
                    {fundraiser.acf.status && <h4><IonText color='success'>*{siteText.fundraiseCompletedTxt}</IonText></h4>}
                  </IonCol>

                  <IonCol size='12'><div dangerouslySetInnerHTML={{ __html: fundraiser.acf.description }}></div></IonCol>
                </IonRow>
              </IonCol>
            </IonRow>

          </IonGrid>

        }
        <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
          <IonContent class="ion-padding">
            <p>{siteText.loginPromtMessage}</p>
            <IonButton onClick={loginFirst} expand='block'><IonText>{siteText.siteLoginBtnTxt}</IonText></IonButton>
            <IonButton routerLink={`/${lan}/signup`} size='small' style={{ textTransform: 'none' }} color="secondary" fill='clear'>{siteText.loginNoAccount}</IonButton>
          </IonContent>
        </IonPopover>
        <Footer></Footer>
      </IonContent>
    </IonPage>
  );
};

export default FundraiserDetail;
